import PropTypes from 'prop-types'
import { X } from '@phosphor-icons/react'
import { Trans, useTranslation } from 'react-i18next'

import RequestSentModal from '../Upselling/RequestSentModal'

const QRCodeSurveysModal = ({ onClose, isExternal, userEmail }) => {
  const { t } = useTranslation(['surveys'])
  return (
    <div className="qr-code-surveys-modal">
      <div className="qr-code-surveys-modal__overlay" onClick={onClose} />
      <div
        className={`qr-code-surveys-modal__container ${isExternal ? 'qr-code-surveys-modal__container--external' : ''}`}
      >
        <button className="qr-code-surveys-modal__close" onClick={onClose}>
          <X size={24} />
        </button>
        {isExternal ? (
          <iframe
            src={`https://elevateoshub.com/embed/surveys?email=${encodeURIComponent(userEmail)}`}
            className="qr-code-surveys-modal__iframe"
            title={t('surveys:qrCodeModal.title')}
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <div className="qr-code-surveys-modal__content">
            <div className="qr-code-surveys-modal__image">
              <img src="/images/upselling/surveys.png" alt={t('surveys:qrCodeModal.title')} />
            </div>
            <div className="qr-code-surveys-modal__info">
              <h2 className="qr-code-surveys-modal__title">{t('surveys:qrCodeModal.title')}</h2>
              <ul className="qr-code-surveys-modal__list">
                <li>
                  <Trans
                    i18nKey="surveys:qrCodeModal.collectBullet"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="surveys:qrCodeModal.shareBullet"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="surveys:qrCodeModal.analyticsBullet"
                    components={[<strong key="0" />]}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="surveys:qrCodeModal.manageBullet"
                    components={[<strong key="0" />]}
                  />
                </li>
              </ul>
              <RequestSentModal buttonClassName="button-black" type="qrCodeSurveys" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

QRCodeSurveysModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isExternal: PropTypes.bool,
  userEmail: PropTypes.string,
}

export default QRCodeSurveysModal
